// const questionsCollection = ["test", "test2", "tes3"];
//   const initialQuestionsList = () => {
//     let ques = [];
//     for (let i = 0; i < questionsCollection.length; i++) {
//       const element = questionsCollection[i];
//       ques.push({ task: element, id: uuid(), selected: false });
//     }
//     return { questions: ques };
//   };

// const questionList = {
//   id: "1-1",
//   title: "title",
//   questions: [
//     { task: element, id: uuid(),  selected: false },
//     { task: element, id: uuid(),  selected: false },
//   ],
// };
import { v4 as uuid } from "uuid";

const imageLists = [
  {
    title: "Stunned Face" /* 标题 */,
    level: "Rookie" /* 困难等级 */,
    showFace: false,
    drawSrc: "./assets/surprise-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/Uxxp0s.jpg",
    id: uuid(),
    checkPoints: ["5", "6", "9", "10"] /* 正确答案的九宫格位置 */,
    imageParts: [
      /* 里面有16张图片 */
      {
        alt: "surprise-0" /* 16分之一图片的标题 */,
        imgsrc: "./assets/images/surprise-01.jpg" /* 16分之一图片地址 */,
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWoon.jpg",
        id: uuid(),
        selected: false /* 图片是不是被选中 */,
      },
      {
        alt: "surprise-1",
        imgsrc: "./assets/images/surprise-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVW7iq.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-2",
        imgsrc: "./assets/images/surprise-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWHJ0.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-3",
        imgsrc: "./assets/images/surprise-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWbWV.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-4",
        imgsrc: "./assets/images/surprise-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWOQU.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-5",
        imgsrc: "./assets/images/surprise-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWqzT.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-6",
        imgsrc: "./assets/images/surprise-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWXyF.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-7",
        imgsrc: "./assets/images/surprise-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWjL4.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-8",
        imgsrc: "./assets/images/surprise-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWxeJ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-9",
        imgsrc: "./assets/images/surprise-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWzw9.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-10",
        imgsrc: "./assets/images/surprise-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfSoR.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-11",
        imgsrc: "./assets/images/surprise-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVf9F1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-12",
        imgsrc: "./assets/images/surprise-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfCJx.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-13",
        imgsrc: "./assets/images/surprise-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfPW6.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-14",
        imgsrc: "./assets/images/surprise-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfFSK.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "surprise-15",
        imgsrc: "./assets/images/surprise-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfkQO.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Speechless Guy",
    level: "Rookie",
    showFace: false,
    drawSrc: "./assets/speechless-guy-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/UxvxXQ.jpg",
    id: uuid(),
    checkPoints: ["5", "6", "9", "10", "13", "14"],
    imageParts: [
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9jYD.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9XFO.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9LTK.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9qw6.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai97O1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9bex.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9TyR.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9ol9.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9ISJ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai94W4.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9hYF.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9ge0.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai96Lq.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9fFU.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai92wV.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "speechless-guy",
        imgsrc: "./assets/images/speechless-guy-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9RoT.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Lego",
    level: "Rookie",
    showFace: false,
    drawSrc: "./assets/lego-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/UxvXp8.jpg",
    id: uuid(),
    checkPoints: ["5", "6", "9", "10"],
    imageParts: [
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSE5Q.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSAUg.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSkVS.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSib8.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSPDf.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSZCj.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSMrV.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSe8s.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSm2n.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSnvq.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSKK0.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6nsK.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6uqO.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6MZD.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSSgI.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "lego",
        imgsrc: "./assets/images/lego-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzz8A.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Daydreamer",
    level: "Rookie",
    showFace: false,
    drawSrc: "./assets/daydreamer-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/UxvT0A.jpg",
    id: uuid(),
    checkPoints: ["4", "5", "6", "8", "9", "10"],
    imageParts: [
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYuVO.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYZKx.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYmqK.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYEx1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYKaD.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apl18x.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apl326.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apllP1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplM5R.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplKa9.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apluVJ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplA2V.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplerF.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplEvT.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplZKU.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "daydreamer",
        imgsrc: "./assets/images/daydreamer-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplmb4.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Boy",
    level: "Rookie",
    showFace: false,
    drawSrc: "./assets/boy-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/Uxvomd.jpg",
    id: uuid(),
    checkPoints: ["1", "2", "5", "6", "9", "10"],
    imageParts: [
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxMA1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/Uxxu7R.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxnB9.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxmnJ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxZX4.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxQtx.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/Uxxlh6.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/Uxx39K.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/Uxx81O.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxGcD.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxJje.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxtnH.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxNBd.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/25/UxxUHA.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQfgK.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "boy",
        imgsrc: "./assets/images/boy-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQ5uD.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Make Faces",
    level: "Senior",
    showFace: false,
    drawSrc: "./assets/make-faces-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/Uxvj1S.jpg",
    id: uuid(),
    checkPoints: ["5", "6", "9", "10"],
    imageParts: [
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzxCd.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzXUe.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzj4H.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzOED.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzqHO.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzbDK.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzTjx.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzog1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzHu6.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzI3R.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCz5C9.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzgBT.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzWEF.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCz2HU.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzh4J.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "make-faces",
        imgsrc: "./assets/images/make-faces-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aCzfN4.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Peashooter",
    level: "Senior",
    showFace: false,
    drawSrc: "./assets/peashooter-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/UxvLff.jpg",
    id: uuid(),
    checkPoints: ["1", "5", "9", "13"],
    imageParts: [
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6gyV.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6cQ0.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6yzq.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6sWn.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6Dij.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6rJs.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP60oQ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6wdg.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6deS.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6UL8.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6tQP.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP63id.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP68JA.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6GRI.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6Nsf.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "peashooter",
        imgsrc: "./assets/images/peashooter-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6Jzt.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Tongue-out Guy",
    level: "Senior",
    showFace: false,
    drawSrc: "./assets/tongue-out-guy-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/UxxPkq.jpg",
    id: uuid(),
    checkPoints: ["5", "6", "9", "10"],
    imageParts: [
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfmTA.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfuFI.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfKYt.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVfMfP.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVflSf.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZy47q.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyoNV.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyhBn.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyfns.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyRXj.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZy2cQ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyB7t.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyc9S.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZystf.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyrAP.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "tongue-out-guy",
        imgsrc: "./assets/images/tongue-out-guy-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyyh8.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Two Birdies",
    level: "Senior",
    showFace: false,
    drawSrc: "./assets/two-birdies-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/Uxx97n.jpg",
    id: uuid(),
    checkPoints: ["4", "5", "8", "9"],
    imageParts: [
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZ6Aud.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZ6FjH.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZ6ige.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZ6P3D.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZ6C9O.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZ6p4K.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZ6SN6.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyzAx.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyvH1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyjBR.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyXu9.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyLjJ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyqc4.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyb3F.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyH9U.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "two-birdies",
        imgsrc: "./assets/images/two-birdies-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aZyThT.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Donald Duck",
    level: "Senior",
    showFace: false,
    drawSrc: "./assets/donald-duck-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/Uxv5OH.jpg",
    id: uuid(),
    checkPoints: ["9", "10"],
    imageParts: [
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWEzq.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apW9eS.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWkJs.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWCdg.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWFij.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWPoQ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apB7VI.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apBoqA.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apBIrd.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apB5KH.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apBhxe.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apBf2D.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apBcUx.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apBg56.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apBRPK.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-duck",
        imgsrc: "./assets/images/donald-duck-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apBW8O.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Chicken in Hat",
    level: "Master",
    showFace: false,
    drawSrc: "./assets/chicken-in-hat-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/Uxv7TI.jpg",
    id: uuid(),
    checkPoints: ["1", "2", "3", "5", "6", "7", "9", "10", "11"],
    imageParts: [
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQW36.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQR9x.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQIDe.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQoHH.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQHUA.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQb4I.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQLCt.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQO8P.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQXgf.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQjv8.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQxKS.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apQzDg.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplSbQ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apl9Ej.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplCUs.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "chicken-in-hat",
        imgsrc: "./assets/images/chicken-in-hat-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/aplP5n.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Dog Head",
    level: "Master",
    showFace: false,
    drawSrc: "./assets/dog-head-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/Uxvbkt.jpg",
    id: uuid(),
    checkPoints: ["4", "5", "6", "7", "8", "9", "10", "11"],
    imageParts: [
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apY8xI.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apY3RA.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYJMt.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYlPH.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYYsP.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYtqf.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYUZ8.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYadS.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYdIg.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apY0iQ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYBGj.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYyMq.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYDRs.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYrzn.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apY6s0.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "dog-head",
        imgsrc: "./assets/images/dog-head-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apYcLV.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Donald Trump",
    level: "Master",
    showFace: false,
    drawSrc: "./assets/donald-trump-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/UxvqtP.jpg",
    id: uuid(),
    checkPoints: [
      "0",
      "1",
      "2",
      "4",
      "5",
      "6",
      "8",
      "9",
      "10",
      "12",
      "13",
      "14",
    ],
    imageParts: [
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWAWn.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWZQ0.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWeyV.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWmLT.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWueU.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWKwF.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWMo4.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWlFJ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apW1Y9.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apW3WR.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWJQx.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWtOK.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWGS1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/26/apWYy6.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSpvt.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "donald-trump",
        imgsrc: "./assets/images/donald-trump-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aPSCKP.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Sneaking Bear",
    level: "Master",
    showFace: false,
    drawSrc: "./assets/sneaking-bear-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/Uxvv6g.jpg",
    id: uuid(),
    checkPoints: ["4", "5", "6", "7", "8", "9", "10", "11"],
    imageParts: [
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6by6.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6IY9.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6oWR.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP67S1.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6HQx.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP62LT.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP65FJ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6WeU.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6fwF.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aP6ho4.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9Dzj.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9NeP.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-13.jpg",
        "https://s1.ax1x.com/2020/07/27/ai90Jg.jpg": "",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-14.jpg",
        "https://s1.ax1x.com/2020/07/27/ai9BWQ.jpg": "",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9ao8.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "sneaking-bear",
        imgsrc: "./assets/images/sneaking-bear-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/ai9Udf.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
  {
    title: "Squirrel",
    level: "Master",
    showFace: false,
    drawSrc: "./assets/squirrel-draw.jpg",
    drawSrcLink: "https://s1.ax1x.com/2020/07/25/UxxSmj.jpg",
    id: uuid(),
    checkPoints: [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "14",
    ],
    imageParts: [
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-01.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWfsg.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-02.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aiCFTf.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-03.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aiCAk8.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-04.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aiCSld.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-05.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aiCp6A.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-06.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aiCPmt.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-07.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aiC9OI.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-08.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/27/aiCi0P.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-09.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWIds.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-10.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVW5Zj.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-11.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWhLQ.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-12.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVW6it.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-13.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWgRf.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-14.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWcJP.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-15.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVWWQS.jpg",
        id: uuid(),
        selected: false,
      },
      {
        alt: "squirrel",
        imgsrc: "./assets/images/squirrel-16.jpg",
        imgsrcLink: "https://s1.ax1x.com/2020/07/29/aVW2z8.jpg",
        id: uuid(),
        selected: false,
      },
    ],
  },
];

// add label
const afterLabel = imageLists.map((qL, a) => {
  const newImgParts = qL.imageParts.map((q, b) => {
    return { ...q, label: `${b}` };
  });

  return { ...qL, imageParts: newImgParts };
});

export default function getQuestionsLists() {
  return afterLabel;
}
